const apiUrl = process.env.NEXT_PUBLIC_API_URL;
const disableApiHostRewrite =
  process.env.NEXT_PUBLIC_DISABLE_API_HOST_REWRITE === "true";

if (!apiUrl) {
  throw new Error("Configure NEXT_PUBLIC_API_URL no arquivo .env.");
}

const LOCAL_API_HOSTS = new Set(["localhost", "127.0.0.1", "0.0.0.0"]);

const resolveApiUrl = () => {
  if (
    process.env.NODE_ENV === "production" ||
    typeof window === "undefined" ||
    disableApiHostRewrite
  ) {
    return apiUrl.replace(/\/$/, "");
  }

  try {
    const configuredUrl = new URL(apiUrl);

    if (!LOCAL_API_HOSTS.has(configuredUrl.hostname)) {
      return configuredUrl.toString().replace(/\/$/, "");
    }

    configuredUrl.hostname = window.location.hostname;
    return configuredUrl.toString().replace(/\/$/, "");
  } catch {
    return apiUrl.replace(/\/$/, "");
  }
};

export const env = { apiUrl: resolveApiUrl() };
